import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_TICKET_REASSIGNMENT,
  CLEAR_TICKET_REASSIGNMENTS,
  FLAG_GETTING_TICKET_REASSIGNMENTS,
  FLAG_TICKET_REASSIGNMENT_ACTIVITY,
  GET_TICKET_REASSIGNMENT,
  GET_TICKET_REASSIGNMENTS,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_TICKET_REASSIGNMENTS:
      return state.setIn(['all', 'loading'], payload);
    case GET_TICKET_REASSIGNMENTS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_TICKET_REASSIGNMENTS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_TICKET_REASSIGNMENT_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_TICKET_REASSIGNMENT:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_TICKET_REASSIGNMENT:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
